import { faHourglass, faLightbulb } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import GptService from '../Services/GptService'
import React, { useState } from 'react';
import Label from './Label';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
export default function TextInput({ gpt, gptOthers, setFieldValue, label, noMargin, placeholder, value, onChange, name, disabled, error, message }) {

	const [localDisabled, setLocalDisabled] = useState(false);

	const onGptClick = () => {
		setLocalDisabled(true)
		const request = GptService.getChatGpt(gpt, value, gptOthers);
		GptService.query(request).then(t => {
			setLocalDisabled(false);
			setFieldValue(name, t[0]['message']['content']);
		}).catch(e => {
			setLocalDisabled(false);
		})
	}
	return (
		<div className={noMargin ? '' : 'mt-4'}>
			{label && <Label text={label} />}
			<div className="flex items-center">
				<input
					type="text"
					className={`
                    form-control
                    block
                    w-full
                    px-3
                    py-1.5
                    text-base
                    font-normal
                    text-gray-700
                    bg-white bg-clip-padding
                    border border-solid border-gray-300
                    rounded
                    transition
                    ease-in-out
                    m-0
                    focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none
				 	${disabled ? 'bg-slate-50' : ''}
					`}
					id={name}
					name={name}
					disabled={disabled || localDisabled}
					onChange={onChange}
					value={value}
					placeholder={placeholder}
				/>
				{gpt && <div onClick={onGptClick} className="ml-2 inline-flex items-center justify-center p-2 bg-yellow-400 rounded-full text-gray-800">
					{localDisabled ? <FontAwesomeIcon icon={faSpinner} spin /> : <FontAwesomeIcon icon={faLightbulb} />}
				</div>}
			</div>
			{message}
			{error && <div className="text-red-600">{error}</div>}
		</div >
	);
}

